import { CircularProgress } from "@mui/material";
import React from "react";
import logo from "../../assets/logo-main.svg";

function Loading() {
  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <img src={logo} style={{ width: 100, marginBottom: 20 }} />
      <CircularProgress style={{ color: "#00166A" }} />
    </div>
  );
}

export default Loading;
